export const getApiUrl = () =>
  process.env.REACT_APP_ENV === 'development'
    ? process.env.REACT_APP_DEVELOPMENT_URL
    : process.env.REACT_APP_PRODUCTION_URL;
